import React, { useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { contactConfig } from "@/config/contactConfig";
import { companyConfig } from "@/config/companyConfig";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import usePostHeroVisibility from "./usePostHeroVisibility";

const FloatingWhatsapp = () => {
  const visible = usePostHeroVisibility();
  const [open, setOpen] = useState(false);
  const phone = String(contactConfig.commercial?.phones?.[0] || "").replace(/\D/g, "");
  if (!phone || !visible) return null;

  const message = encodeURIComponent("Hola, quiero conversar sobre un proyecto de medios de pago con CAPTEC.");
  const commercialHref = `https://wa.me/${phone}?text=${message}`;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <div className="assistant-launcher">
        <PopoverTrigger asChild>
          <button type="button" className="assistant-launcher__button" aria-label="Abrir asistente CAPTEC">
            <img src="/assets/assistant/captec-agent.png" alt="" width="58" height="58" draggable={false} />
        <span className="absolute -bottom-1 -right-1 z-20 inline-flex h-6 w-6 items-center justify-center rounded-full border-2 border-[#07111f] bg-[#25D366] text-white shadow-[0_8px_18px_rgba(0,0,0,0.3)] sm:h-7 sm:w-7">
          <svg viewBox="0 0 32 32" aria-hidden="true" className="h-3.5 w-3.5 fill-current sm:h-4 sm:w-4">
            <path d="M16.02 3.2c-7.04 0-12.76 5.7-12.76 12.72 0 2.24.59 4.43 1.71 6.36L3.15 28.8l6.68-1.75a12.8 12.8 0 0 0 6.18 1.58h.01c7.03 0 12.75-5.71 12.75-12.73A12.7 12.7 0 0 0 16.02 3.2Zm0 23.28h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-3.96 1.04 1.06-3.85-.25-.4a10.54 10.54 0 0 1-1.63-5.64c0-5.83 4.75-10.57 10.59-10.57 2.82 0 5.48 1.1 7.48 3.1a10.48 10.48 0 0 1 3.1 7.47c-.01 5.83-4.76 10.56-10.59 10.56Zm5.8-7.92c-.32-.16-1.88-.92-2.17-1.03-.29-.1-.5-.16-.71.16-.21.32-.82 1.03-1 1.24-.19.21-.37.24-.69.08-.32-.16-1.34-.49-2.56-1.58a9.6 9.6 0 0 1-1.77-2.2c-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.18.21-.31.32-.52.1-.21.05-.4-.03-.56-.08-.16-.71-1.71-.98-2.34-.26-.62-.52-.54-.71-.55h-.61c-.21 0-.56.08-.85.4-.29.32-1.11 1.08-1.11 2.64 0 1.56 1.14 3.07 1.3 3.28.16.21 2.24 3.42 5.43 4.8.76.32 1.35.52 1.81.67.76.24 1.45.21 2 .13.61-.09 1.88-.77 2.14-1.51.27-.74.27-1.37.19-1.5-.08-.13-.29-.21-.61-.37Z" />
          </svg>
        </span>
          </button>
        </PopoverTrigger>
      </div>
      <PopoverContent side="top" align="end" sideOffset={14} collisionPadding={16} className="assistant-panel" aria-label="Asistente CAPTEC">
        <div className="assistant-panel__header">
          <h2>Asistente CAPTEC</h2>
          <button type="button" onClick={() => setOpen(false)} aria-label="Cerrar asistente"><X size={18} /></button>
        </div>
        <p>¿Buscas soporte o quieres implementar una solución?</p>
        <div className="assistant-panel__links">
          <a href={commercialHref} target="_blank" rel="noreferrer">Hablar con Comercial</a>
          <a href={companyConfig.serviceDeskUrl} target="_blank" rel="noreferrer">Soporte 24/7</a>
          <Link to="/servicios" onClick={() => setOpen(false)}>Explorar soluciones</Link>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default FloatingWhatsapp;
